import React, { useState, useEffect } from 'react'
import { MenuItem, Position, ButtonProps } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button } from '..'

interface YearSelectProps {
  value: number | null
  onChange: (year: number) => void
  options?: number[] | (() => number[])
  buttonProps?: ButtonProps
  className?: string
  itemDisabled?: (year: number) => boolean
}

const YEAR_OPTIONS = (function () {
  const years = []
  const start = new Date().getFullYear() - 2
  for (let i = 0; i < 10; i++) {
    years.push(start + i)
  }

  return years
})()

export const createYearOptions = (start = 2016, range = 10) => {
  const years = []
  const end = start + range

  for (let temp = start; temp < end; temp++) {
    years.push(temp)
  }

  return years
}

const YearSelect = Select2<number>

function YearSelectWrapper({
  value,
  className = '',
  options,
  onChange,
  buttonProps,
  itemDisabled,
}: YearSelectProps) {
  const [activeItem, setActiveItem] = useState<number | null>(value)
  useEffect(() => setActiveItem(value), [value])

  return (
    <YearSelect
      activeItem={activeItem}
      onActiveItemChange={(item) => setActiveItem(item)}
      className={className}
      scrollToActiveItem
      popoverProps={{
        minimal: true,
        position: Position.BOTTOM_RIGHT,
      }}
      filterable={false}
      items={options ? (Array.isArray(options) ? options : options()) : YEAR_OPTIONS}
      itemDisabled={itemDisabled}
      itemRenderer={(year, { handleClick, modifiers }) => (
        <MenuItem
          key={year}
          active={modifiers.active}
          onClick={handleClick}
          text={year}
          disabled={modifiers.disabled}
        />
      )}
      onItemSelect={onChange}
    >
      <Button {...buttonProps} text={value || '-Select-'} rightIconName="chevron-down" />
    </YearSelect>
  )
}

export default YearSelectWrapper
